import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../../common/Api";
import { Division } from "../../domains/Division";
import { AdminStore } from "../AdminStore";

export class DivisionsStore {
  rootStore: AdminStore;

  divisions: Division[] = [];
  loading = false;

  constructor(rootStore: AdminStore) {
    makeAutoObservable(this, {
      rootStore: false,
    });
    this.rootStore = rootStore;
  }

  @action refresh() {
    this.loading = true;
    return Api.division.list().then((res) => {
      runInAction(() => {
        this.divisions = res.data.findDivision;
        this.loading = false;
      });
    });
  }
}
